import { createReducer, on, createFeature } from '@ngrx/store'
import {
  clearUnassignedUsers,
  createAssignedTo,
  createAssignedToFailure,
  createAssignedToSuccess,
  createPermissionSet,
  createPermissionSetFailure,
  createPermissionSetSuccess,
  deleteAssignedTo,
  deleteAssignedToFailure,
  deleteAssignedToSuccess,
  loadAssignedTo,
  loadAssignedToFailure,
  loadAssignedToSuccess,
  loadPermissionSetByIdFailure,
  loadPermissionSetByIdSuccess,
  loadPermissionSets,
  loadPermissionSetsFailure,
  loadPermissionSetsSuccess,
  loadUnassignedUsersSuccess,
  resetPermissionSetState,
  updatePermissionSet,
  updatePermissionSetFailure,
  updatePermissionSetSuccess,
  upsertValidUpto,
  upsertValidUptoFailure,
  upsertValidUptoSuccess
} from './permission-sets.actions'
import { PermissionSetAssignedTo, PermissionSetState } from './permission-sets.state'

export const initialState: PermissionSetState = {
  permissionSets: [],
  loading: false,
  error: null,
  totalCount: 0,
  assignedTo: null,
  permissionSet: null,
  unassignedUsers: null
}

export const permissionSetReducer = createReducer(
  initialState,
  on(loadPermissionSets, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadPermissionSetsSuccess, (state, { permissionSets, totalCount }) => ({
    ...state,
    permissionSets: permissionSets,
    loading: false,
    error: null,
    totalCount
  })),
  on(loadPermissionSetsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createPermissionSet, state => ({ ...state, loading: true })),
  on(createPermissionSetSuccess, (state, { permissionSet }) => ({
    ...state,
    permissionSets: [...state.permissionSets, permissionSet],
    loading: false
  })),
  on(createPermissionSetFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updatePermissionSet, state => ({ ...state, loading: true })),
  on(updatePermissionSetSuccess, (state, { permissionSet }) => ({
    ...state,
    permissionSet,
    loading: false
  })),
  on(updatePermissionSetFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(loadPermissionSetByIdSuccess, (state, { permissionSet }) => {
    // console.log('PermissionSet', PermissionSet)
    return {
      ...state,
      permissionSet,
      error: null
    }
  }),
  on(loadPermissionSetByIdFailure, (state, { error }) => ({
    ...state,
    permissionSet: null,
    error
  })),
  on(loadAssignedTo, upsertValidUpto, deleteAssignedTo, createAssignedTo, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(
    loadAssignedToSuccess,
    (state, action: { totalCount: number; assignedPermissionSets: PermissionSetAssignedTo[] }) => ({
      ...state,
      loading: false,
      error: null,
      assignedTo: action.assignedPermissionSets,
      totalCount: action.totalCount
    })
  ),
  on(
    upsertValidUptoSuccess,
    deleteAssignedToSuccess,
    createAssignedToSuccess,
    (state, { assignedTo }) => ({
      ...state,
      loading: false,
      error: null,
      assignedTo
    })
  ),
  on(
    loadAssignedToFailure,
    upsertValidUptoFailure,
    deleteAssignedToFailure,
    createAssignedToFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error
    })
  ),
  on(loadUnassignedUsersSuccess, (state, { users }) => ({
    ...state,
    unassignedUsers: users
  })),
  on(resetPermissionSetState, () => initialState),
  on(clearUnassignedUsers, state => ({
    ...state,
    unassignedUsers: []
  }))
)

// Create the feature for the business state
export const permissionSetFeature = createFeature({
  name: 'permissionSet', // Feature name
  reducer: permissionSetReducer
})
export type { PermissionSetState }
// Export the feature's selectors
export const {
  name,
  reducer,
  selectPermissionSets,
  selectLoading,
  selectError,
  selectPermissionSet,
  selectAssignedTo,
  selectTotalCount
} = permissionSetFeature
